import { AccordionContainer } from "../../../../../common/components/accordion/accordion.module";
import { InputContainer } from "../../../../../common/components/form/input/containers/input.container";


export const DbaRegistriesBasicInfoComponent = ({ 
    subDomains, domains, countries, opsnumber, handleBacicInnerFormChange, selectedDbnpRegistry, dbnpname 
}: any) => (
    <>
        <AccordionContainer
            child={
                <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>

                    <InputContainer
                    isDisabled
                        label="DBNP Name"
                        labelField="Name"
                        list={dbnpname}
                        onValueChange={(event: any, newValue: any) => {
                            handleBacicInnerFormChange(
                                event.target.value,
                                'DBNPId',
                            );
                        }}
                        optionName='Choose DBNP Name'
                        type="select"
                        value={selectedDbnpRegistry?.DBNPId}
                        valueField="Id"
                    />
                    <InputContainer
                    isDisabled

                        label="Published"
                        name="IsPublished"
                        onValueChange={(event: any) => {
                            handleBacicInnerFormChange(
                                event,
                                'IsPublished',
                            )
                        }}
                        type="checkbox"
                        value={selectedDbnpRegistry?.IsPublished}
                    />
                    <InputContainer
                        label="OPS number"
                        labelField="Description"
                        list={opsnumber}
                        onValueChange={(event: any, newValue: any) => {
                            handleBacicInnerFormChange(
                                event.target.value,
                                'ops_no',
                            );
                        }}
                        optionName='Choose OPS number'
                        type="select"
                        value={selectedDbnpRegistry?.ops_no}
                        valueField="Value"
                    />
                    <InputContainer
                    isDisabled
                        label="Name of Authorised Signature"
                        name="name_of_authorised_signatory"
                        onValueChange={(event: any) => {
                            handleBacicInnerFormChange(
                                event.target.value,
                                'name_of_authorised_signatory',
                            )
                        }}
                        type="text"
                        value={selectedDbnpRegistry?.name_of_authorised_signatory}
                    />
                    <InputContainer
                    isDisabled
                        label="Email"
                        name="email_id"
                        onValueChange={(event: any) => {
                            handleBacicInnerFormChange(
                                event.target.value,
                                'email_id',
                            )
                        }}
                        type="text"
                        value={selectedDbnpRegistry?.email_id}
                    />
                    <InputContainer
                    isDisabled

                        label="Phone Number"
                        name="mobile_no"
                        onValueChange={(event: any) => {
                            handleBacicInnerFormChange(
                                event.target.value,
                                'mobile_no',
                            )
                        }}
                        type="number"
                        value={selectedDbnpRegistry?.mobile_no}
                    />
                    <InputContainer
                        label="Country Name"
                        labelField="Name"
                        list={countries}
                        onValueChange={(event: any, newValue: any) => {
                            handleBacicInnerFormChange(
                                event.target.value,
                                'country',
                            );
                        }}
                        optionName='Choose Country'
                        type="select"
                        value={selectedDbnpRegistry?.country}
                        valueField="Name"
                    />
                    <InputContainer
                        isDisabled
                        label="Subscriber Id"
                        name="subscriber_id"
                        onValueChange={(event: any) => {
                            handleBacicInnerFormChange(
                                event.target.value,
                                'subscriber_id',
                            )
                        }}
                        type="text"
                        value={selectedDbnpRegistry?.subscriber_id}
                    />
                    <InputContainer
                        isDisabled
                        label="Unique Key"
                        name="unique_key_id"
                        onValueChange={(event: any) => {
                            handleBacicInnerFormChange(
                                event.target.value,
                                'unique_key_id',
                            )
                        }}
                        type="text"
                        value={selectedDbnpRegistry?.unique_key_id}
                    />
                    <InputContainer
                        isDisabled
                        label="Callback URL"
                        name="callback_url"
                        onValueChange={(event: any) => {
                            handleBacicInnerFormChange(
                                event.target.value,
                                'callback_url',
                            )
                        }}
                        type="text"
                        value={selectedDbnpRegistry?.callback_url}
                    />
                    <InputContainer
                        isDisabled
                        label="Subscriber URL"
                        name="subscriber_url"
                        onValueChange={(event: any) => {
                            handleBacicInnerFormChange(
                                event.target.value,
                                'subscriber_url',
                            )
                        }}
                        type="text"
                        value={selectedDbnpRegistry?.subscriber_url}
                    />
                    <InputContainer
                    

                        label="Domain"
                        labelField="Name"
                        list={domains}
                        onValueChange={(event: any, newValue: any) => {
                            handleBacicInnerFormChange(
                                event.target.value,
                                'domain',
                            );
                        }}
                        optionName='Choose Domain Name'
                        type="select"
                        value={selectedDbnpRegistry?.domain}
                        valueField="Id"
                    />
                    <InputContainer
                        label="Sub Domain"
                        labelField="Name"
                        list={subDomains}
                        onValueChange={(event: any, newValue: any) => {
                            handleBacicInnerFormChange(
                                event.target.value,
                                'SubDomainId',
                            );
                        }}
                        optionName='Choose SubDomain Name'
                        type="select"
                        value={selectedDbnpRegistry?.SubDomainId}
                        valueField="Id"
                    />
                    <InputContainer
                        label="Type"
                        name="type"
                        onValueChange={(event: any) => {
                            handleBacicInnerFormChange(
                                event.target.value,
                                'type',
                            )
                        }}
                        type="text"
                        value={selectedDbnpRegistry?.type}
                    />
                    <InputContainer
                        label="MSN"
                        name="msn"
                        onValueChange={(event: any) => {
                            handleBacicInnerFormChange(
                                event,
                                'msn',
                            )
                        }}
                        type="checkbox"
                        value={selectedDbnpRegistry?.msn}
                    />
                    <InputContainer
                    isDisabled

                        label="Address of Authorised Signature"
                        name="address_of_authorisedSignatory"
                        onValueChange={(event: any) => {
                            handleBacicInnerFormChange(
                                event.target.value,
                                'address_of_authorisedSignatory',
                            )
                        }}
                        type="text"
                        value={selectedDbnpRegistry?.address_of_authorisedSignatory}
                    />
                </div>
            }
            expandedPanel="basicInfo"
            headerTitle="Basic Info"
        />
    </>
)
export default DbaRegistriesBasicInfoComponent;
